import React, { useMemo, useState } from "react";
import "./GenericList.scss";
import { svgs } from "../../common/assats";

interface GenericListProps<T> {
    items: T[];
    filterKey: keyof T;
    title?: string;
    subTitle?: string;
    renderItem: (item: T) => React.ReactNode;
    placeholder?: string;
}

const GenericList = <T,>({
    items,
    filterKey,
    title,
    subTitle,
    renderItem,
    placeholder = "Search...",
}: GenericListProps<T>) => {
    const [search, setSearch] = useState<string>("");

    const filteredItems = useMemo(() => {
        if (!items) return [];
        return items.filter((item) =>
            String(item[filterKey]).toLowerCase().includes(search.toLowerCase())
        );
    }, [items, search, filterKey]);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
    };

    return (
        <div className="generic-list-container">
            <div className="generic-list-header">
                <h2 className="list-title">{title}</h2>
                {subTitle && <p className="list-subtitle">{subTitle}</p>}
            </div>
            <div className="search-container">
                <div className="search-wrapper">
                    <span className="search-icon"></span>
                    <svgs.logos.Search className="search-icon" />
                    <input
                        type="text"
                        placeholder={placeholder}
                        value={search}
                        onChange={handleSearchChange}
                        className="search-input"
                    />
                </div>
            </div>
            <div className="items-list">
                <ul>
                    {filteredItems.map((item, index) => (
                        <li key={index} className="list-item">
                            {renderItem(item)}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default GenericList;
